import React from "react";
import styled from "@emotion/styled";
import { CoveragesCard, ActionLabelCard, Divider, Flex, InsuranceConditions, OfferHeaderCard } from 'src/components';
import { mediaQuery, setOneTimeToggle, useAppDispatch } from "src/common";
import { Card } from "./card";

const CardStyle = styled(Card)({
  padding: '16px 12px',

  [mediaQuery('mobile')]: {
    padding: '20px'
  },
})

interface OfferSummaryCardProps {
  offer: any;
  documents?: Array<{ title: string, src: string }>;
  loading?: boolean;
  oneTimeToggle?: boolean;
  className?: string;
}

export const OfferSummaryCard = ({ offer, documents = [], oneTimeToggle = false, className }: OfferSummaryCardProps) => {
  const dispatch = useAppDispatch();

  const discountPercentage = ((offer.total.generalTransferWithInstallments - offer.total.generalTransfer) / offer.total.generalTransferWithInstallments) * 100;
  const roundedDiscountPercentage = Math.round(discountPercentage); // Zaokruživanje na više bez decimalnih mjesta

  return (
    <CardStyle radius={12} className={className}>
      <Flex vertical gap={12}>
        <OfferHeaderCard
          brandName={offer.supplementary.brandCode}
          offerLabel={offer.supplementary.label}
          price={oneTimeToggle ? offer.total.generalTransfer : (offer.total.generalTransferWithInstallments / 12)}
          priceType={oneTimeToggle ? 'yearly' : 'monthly'}
          logoUrl={offer.supplementary.logoUrl}
          discountPercentage={roundedDiscountPercentage}
          handlePriceTypeChange={() => dispatch(setOneTimeToggle(!oneTimeToggle))}
        />
        <Divider dashed />
        <ActionLabelCard text={offer.supplementary.actionLabel} />
        <CoveragesCard isExpanded={true} coverages={offer.supplementary.includedInPrice} />
        <Divider dashed />
        <InsuranceConditions documents={documents} />
      </Flex>
    </CardStyle>
  )
};

